export const invertedMessages = {
  Recommended: 'CERTS_SAVI_RECOMMENDED_LABEL',
  'Smart {action} {count} {pluralizeItems}': 'CERTS_SAVI_ACTION_ITEMS_INFO',
  'All Smart {reviewedActionConfirmation} will be cancelled':
    'SAVI_REVIEW_ACTION_CONFIRMATION',
  'You have manually reviewed {manuallyReviewedTotal} {pluralizeItems}':
    'SAVI_MANUALLY_REVIEWED_ITEMS',
  'Keep Your {manuallyReviewedTotal} {pluralizeItems}': 'SAVI_KEEP_YOUR_ITEMS',
  'Cancel Smart {manuallyReviewedActionConfirmation}':
    'SAVI_CANCEL_SMART_ACTIONS',
};
